import React, { useContext, useEffect, useState } from "react";
import { $CommonServiceFn, Services } from "../network/Services";
import  $Service_Url, { CounterBaseUrl } from '../network/url'
import config from '../config.json'
import { useConfirm } from "./ConfirmationToaster";

import { isNotValidNullUndefile } from "../control/Constant";
import SwitchRole from "./SwitchRole";
import Loader from "./Loader";


const TopHead = (props) => {
 const logoutUrl = (config?.demo) ? "https://aologinuat.agingoptions.com/" : "https://Unilogin.agingoptions.com/";

  const [userdetails, setUserDetails] = useState({});
  const [logoUrl, setLogoUrl] = useState(null);
  const [useLoader, setuseLoader] = useState(false)
  const [compnyName, setCompnyName] = useState('')
  let sessionSubtenantId = sessionStorage.getItem('SubtenantId');
  let subtenantName = sessionStorage.getItem('subtenantName');
//   const context = useContext(globalContext);
  const confirm = useConfirm();

  useEffect(() => {
    const userDetails = JSON.parse(sessionStorage.getItem("userLoggedInDetail"));
    let sessionSubtenantId = sessionStorage.getItem('SubtenantId');
    if(sessionSubtenantId==undefined){
      const subtenantId = getCookie("subtenantId");
      sessionStorage.setItem("SubtenantId", subtenantId)
    }
    setUserDetails(userDetails);
    userLogo();
  }, []);

useEffect(() => {
  const interval = setInterval(() => {
    const name = sessionStorage.getItem('companyName') || "";
    setCompnyName(name);
  }, 500);

  return () => clearInterval(interval);
}, []);



  const getCookie =(name) => {
    const cookieString = document.cookie;
    const cookies = cookieString.split('; ');
    for (const cookie of cookies) {
      const [cookieName, cookieValue] = cookie.split('=');
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null; // Return null if the cookie is not found
  }
   const setCookie = (name, value, minutes) => {
    const expirationDate = new Date();
    expirationDate.setTime(expirationDate.getTime() + minutes * 60 * 1000); // Convert minutes to milliseconds
    document.cookie = `${name}=${value};expires=${expirationDate.toUTCString()};path=/`;
  }



  const userLogo = () => {
    const currentSubtenantId = sessionStorage.getItem('SubtenantId'); // always read fresh
    const subtenantLogoUrl = getCookie("subtenantLogoUrl");
    const subtenantId = getCookie("subtenantId");
    if (subtenantId == currentSubtenantId && isNotValidNullUndefile(subtenantLogoUrl) && subtenantLogoUrl != 'undefined') {
      setLogoUrl(subtenantLogoUrl);
      return;
    }

    let subtenantObj = {
      subtenantId: currentSubtenantId
    }
    $CommonServiceFn.InvokeCommonApi("POST", $Service_Url.getSubtenantDetails, subtenantObj,
      (response) => {
        if (response) {
          setLogoUrl(response.data.data[0].subtenantLogoUrl)
          setCookie("subtenantLogoUrl", response.data.data[0].subtenantLogoUrl)
          // Do NOT overwrite subtenantId cookie here — Dashboard manages it on company switch
          sessionStorage.setItem("subtenantName", response.data.data[0].subtenantName)
        }
      }
    );
  };

  const handleLogout = async () => {
    // let confirmQuestion = await context.confirm(true, confirmationMsg, "Confirmation");
    // if (!confirmQuestion) return;
    // alert("l")

    handleLogouts();
  };
   const handleLogouts = (e) => {
        const stateObj = JSON.parse(sessionStorage.getItem('stateObj'));
        window.sessionStorage.clear();
        const params = `Account/Signout?appState=${stateObj.appState}&userId=${stateObj.userId}&roleId=${stateObj.roleId}&loggenInId=${stateObj.loggenInId}&success=true`;
        window.location.replace(logoutUrl + params);
    }

    const handleAppointment = async()=>{
      let loginUserId = sessionStorage.getItem('SessPrimaryUserId');
      let AuthToken = sessionStorage.getItem('AuthToken');
      let stateObj = sessionStorage.getItem('stateObj');
      const userLoggedInDetail = sessionStorage.getItem("userLoggedInDetail");
     const dataToEncode = {
      subtenantId: sessionSubtenantId,
      subtenatName: subtenantName,
      authToken : AuthToken,
      stateObj: JSON.parse(stateObj),
      userLoggedInDetail:JSON.parse(userLoggedInDetail)
    };

    let jsonObj = {
      "moConId": null,
      "moduleConnectionRequest": '',
      "moduleConnectionResponse": JSON.stringify(dataToEncode),
      "isActive": true,
      "requestedFor": loginUserId,
      "upsertedBy": loginUserId
    }

    setuseLoader(true)
    const getModuleConnectparams = await Services.upsertModuleConnectservice(jsonObj)
    const baseUrl1 = `${CounterBaseUrl}Dashboard`
    const redirectUrl = `${baseUrl1}?moConId=${getModuleConnectparams?.data?.[0]?.moConId}`
    window.location.href = redirectUrl
    }
  return (
    <>


      <div  className={`row ${(props?.queryData?.paymnetFromIntake !== "true" && props?.queryData?.paymnetFromEventCoordinator !== "true") ? "p-2" : "m-4 pe-4"} ${(props.stateShow!="assignRoles")?"topHeadParalegalHeight":"topHeadAssRoleHeight"}`} style={{width: "100%",backgroundColor: "white",display:"flex",justifyContent:"space-between"}}>
        {useLoader && <div className='fixed inset-0 z-50 bg-white bg-opacity-30 backdrop-blur-sm  pointer-events-auto'>
          <Loader useLoader={useLoader} />
        </div>}
        <div className="col-7 d-flex align-items-center gap-2 ms-1"style={{display:"flex"}}>
          <img src={isNotValidNullUndefile(logoUrl) ? logoUrl : ""} alt="Subtenant Logo" className="" style={{ maxWidth: "120px", height: "50px", width: "100%" }} />
          <div className="vr h-50 align-items-center mt-4 mx-1"></div>
        </div>
        <div className="col-5  d-flex justify-content-end mt-auto mb-auto">
          <div className="useNewDesignSCSS">
            <div className="d-flex row justify-content-end flex-row h-100">
              <div className="d-flex justify-content-center align-items-center" style={{display:"flex"}}>
                <div className="d-flex justify-content-center align-items-center px-2 py-1" style={{ background: '#dedede', borderRadius: '5px', height: '80%',display:"flex",marginTop:"auto",marginBottom:"auto"}}>
                  <img className="me-2 mt-0" src="/ProfilebrandColor2.svg" alt="user" style={{ width: "30px" }} />
                  <div className="cursor-pointer d-flex flex-column mt-auto mb-auto">
                    <p className="text-dark d-inline-block m-0 me-2" style={{ fontSize: "12px" }} >{userdetails?.memberName}</p>
                    <p className="text-dark d-inline-block m-0 p-0 me-2" style={{ fontSize: "12px", color: '#7c7c7c' }} >{userdetails?.primaryEmailId}</p>
                  </div>
                </div>

                {/* <div className="vr align-item-center divder-cls" style={{ height: "20px", marginTop: "20px", padding: "0.8px" }}></div> */}

                {/* {props?.queryData?.paymnetFromIntake !== "true" && props?.queryData?.paymnetFromEventCoordinator !== "true" && (compnyName == "life_point_law" || !isNotValidNullUndefile(compnyName)) && <div className='me-1 ms-4 d-flex ' style={{ backgroundColor: "#720c20", color: "#fff", display: "flex", marginTop: "auto", marginBottom: "auto", border: "none", borderRadius: "5px", padding: "0.3rem",cursor:"pointer" }}>
                    <button className='logout-btn m-1 hide-div-class bg-[#720c20] text-white' style={{ display: "flex", alignItems: "self-end" }} onClick={handleAppointment}>Appointment Booking</button>
                  </div>} */}

                {props?.queryData?.paymnetFromIntake !== "true" && props?.queryData?.paymnetFromEventCoordinator  !== 'true' && <SwitchRole />}
                {props?.queryData?.paymnetFromIntake !== "true" && props?.queryData?.paymnetFromEventCoordinator  !== 'true' && (
                  <div className='me-1 d-flex' style={{ backgroundColor: "#000", color: "#fff", display: "flex", marginTop: "auto", marginBottom: "auto", border: "none", borderRadius: "5px", padding: "0.3rem" }}>
                    <button className='logout-btn m-1 hide-div-class' style={{ display: "flex", alignItems: "self-end" }} onClick={handleLogout}>
                      <img src="/logoutbtn.png" style={{ height: "20px" }} className='me-1 mt-0' />
                      Logout</button>
                  </div>
                )}
              </div>
            </div>
            {/* } */}
          </div>
        </div>

      </div>
 </>

  );
};

export default TopHead;